




































































































import Vue from "vue";
import { AppAnalytics } from "@/analytics";
export default Vue.extend({
  props: {
    hasBack: {
      type: Boolean,
      default: false
    },
    step: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: "Welcome to Cognni"
    },
    subtitle: {
      type: String,
      default: ""
    },
    desc: {
      type: String,
      default: ""
    }
  },
  methods: {
    back() {
      if (history.state) this.$router.back();
    },
    onVisitSite(link: string) {
      AppAnalytics.report({
        eventName: `Onboarding_click on site (${this.$route.name} page)`
      });
      window.open(link, "_blank");
    },
    support(link: string) {
      AppAnalytics.report({
        eventName: `Onboarding_click on support (${this.$route.name} page)`
      });
      window.open(link, "_blank");
    }
  }
});
